export default {
  components: {
    input: 'input',
    select: 'select',
    checkbox: 'checkbox',
    switcher: 'switcher',
  },
  actions: {
    text: 'text',
    button: 'button',
    checkbox: 'checkbox',
  },
  serverModes: {
    add: 'add',
    edit: 'edit',
  },
}
